module.exports = __webpack_public_path__ + "media/images/pages/careers-week/beth-efd97eb6c4b486e4bc97de227191860b.jpg";